import { render, staticRenderFns } from "./si_review.vue?vue&type=template&id=1fbe0fbf&scoped=true&"
import script from "./si_review.vue?vue&type=script&lang=js&"
export * from "./si_review.vue?vue&type=script&lang=js&"
import style0 from "./si_review.vue?vue&type=style&index=0&id=1fbe0fbf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbe0fbf",
  null
  
)

export default component.exports